export const USER_ROLES = [
  { id: 'landlord', label: 'Private landlord', desc: 'I own and manage my own portfolio.' },
  { id: 'agent', label: 'Letting agent', desc: 'I manage properties on behalf of clients.' },
  { id: 'investor', label: 'Property investor', desc: 'I run a buy-to-let or HMO portfolio.' },
  { id: 'team', label: 'Property team', desc: "We're a multi-person agency or fund." },
];
